<template>
  <button
    class="btn btn-sm"
    :class="getButtonClasses(button)"
    @click="setExpectedAnswerValueLocal(button.id)"
    type="button"      
  >
    {{ button.answer }}
  </button>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { expectedAnswerTypeEffective, expectedAnswerTypeTolerated } from "@/entities/questionaire/answers/ExpectedAnswerTypeReChallenge";

@Component
export default class AppButtonToggleReChallenge extends Vue {
  @Prop()
  button!: any;

  @Prop()
  readonly expectedAnswer!: expectedAnswerTypeEffective | expectedAnswerTypeTolerated | undefined;
  localExpectedAnswer: expectedAnswerTypeEffective | expectedAnswerTypeTolerated | undefined =
    this.expectedAnswer || undefined;

  @Watch("expectedAnswer")
  onExpectedAnswerChanged(val: expectedAnswerTypeEffective | expectedAnswerTypeTolerated) {
    this.localExpectedAnswer = val;
  }

  setExpectedAnswerValueLocal(val: expectedAnswerTypeEffective | expectedAnswerTypeTolerated) {
    this.localExpectedAnswer =
      this.localExpectedAnswer?.toLowerCase() === val.toLowerCase() ? undefined : val;
    this.$emit("input", this.localExpectedAnswer);
  }

  getButtonClasses(obj: { id: expectedAnswerTypeEffective | expectedAnswerTypeTolerated; type: string }) {
    let classes = [];
    if (this.localExpectedAnswer?.toLowerCase() != obj.id.toLowerCase()) {
      classes.push("btn-turned-off");
    } else {
      classes.push(`btn-${obj.type}`);
    }

    return classes;
  }
}
</script>

<style lang="scss" scoped>
.btn {
  padding: 0;
  width: 85px;
  height: 27px;
}

.btn-turned-off {
  color: gray;
  background-color: #f8f9fa;
  border: 0;

  &:hover {
    color: gray;
    background-color: #e2e6ea;
  }
}
</style>
